import axios from 'axios'
import _ from 'lodash'

// state
const state = {
	sendLoader: false,
	canSelectFile: false,
	canUploadFile: false
}

const getters = {
	
}


// mutations
const mutations = {
	TOGGLE_BOOLEAN_STATE(state, {key, bool}){
		eval('state.' + key + ' = bool');
	},
}

// actions
const actions = {
	toggleBooleanState({commit}, {key, bool}){
		commit('TOGGLE_BOOLEAN_STATE', {key: key, bool: bool});
	},

	// setCanUploadFile ({commit}, bool){
	// 	commit('TOGGLE_BOOLEAN_STATE', {'key': 'canUploadFile', 'bool': bool});
	// },

	// setCanSelectFile ({commit}, bool){
	// 	commit('TOGGLE_BOOLEAN_STATE', {'key': 'canSelectFile', 'bool': bool});
		
	// },

	// setSendLoader ({commit}, bool){
	// 	commit('TOGGLE_BOOLEAN_STATE', {'key': 'sendLoader', 'bool': bool});
	// },
}

export default {
    namespaced: true,
	state,
	getters,
	mutations,
	actions
}